<template>
  <div class="newsletter">
    <div class="container text-center">
      <div class="row">
        <div class="col-sm-12 col-md-10 col-md-offset-1">
          <h2>Get Early Access To Vestbee!</h2>
          <h5>
            We invite all interested entrepreneurs, investors and corporates to
            participate in the closed beta version of our platform!
          </h5>
          <router-link
            class="cta btn btn-primary btn-lg"
            :to="{ name: 'subscribePage' }"
          >
            Request Early Access!
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsletterForm from './NewsletterForm.vue'

export default {
  components: { NewsletterForm },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

.cta {
  background: $primary;
  border-color: $primary;
  color: $yellow;
  margin-bottom: 64px;

  &:hover {
    background: #252425;
  }
}
</style>
